import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Comlogo from "../../Assets/Comlogo.png";
import "./footer.css";

const Footer = ({ servicesRef }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const handleHomeClick = (e) => {
        // If we're already on the home page, prevent default navigation and scroll to top
        if (location.pathname === '/') {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    const handleServiceClick = (e) => {
        // If we're already on the home page, prevent default navigation and scroll to services
        if (location.pathname === '/') {
            e.preventDefault();
            if (servicesRef?.current) {
                servicesRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        } else {
            // If not on home page, navigate to home and then scroll to services
            e.preventDefault();
            navigate('/');
            // Wait for navigation to complete before scrolling
            setTimeout(() => {
                if (servicesRef?.current) {
                    servicesRef.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }, 100);
        }
    };

    return (
        <footer className="footer-container">
            <div className="footer-content">
                {/* Company Info Section */}
                <div className="footer-section company-info">
                    <img src={Comlogo} alt="Born2Scale Logo" className="footer-logo" />
                    <p className="company-description">
                        Born2Scale is your partner in digital growth. We specialize in data-driven marketing strategies that help businesses scale faster, smarter, and sustainably.
                    </p>
                </div>

                {/* Quick Links Section */}
                <div className="footer-section quick-links">
                    <h3>Quick Links</h3>
                    <ul>
                        <li><NavLink to="/" onClick={handleHomeClick}>Home</NavLink></li>
                        <li><NavLink to="/serviceDM">Digital Marketing</NavLink></li>
                        <li><NavLink to="/serviceWEB">Website Development</NavLink></li>
                        <li><NavLink to="/serviceOM">Offline Marketing</NavLink></li>
                        <li><NavLink to="/serviceSB">Strategy Building</NavLink></li>
                        <li><NavLink to="/serviceBC">Business Consultation</NavLink></li>
                    </ul>
                </div>

                {/* Services Section */}
                <div className="footer-section services">
                    <h3>Our Services</h3>
                    <ul>
                        <li onClick={handleServiceClick} style={{ cursor: 'pointer' }}>Meta Ads & Content Creation</li>
                        <li onClick={handleServiceClick} style={{ cursor: 'pointer' }}>LinkedIn & YouTube Marketing</li>
                        <li onClick={handleServiceClick} style={{ cursor: 'pointer' }}>Website Development</li>
                        <li onClick={handleServiceClick} style={{ cursor: 'pointer' }}>SEO & Google Ads</li>
                        <li onClick={handleServiceClick} style={{ cursor: 'pointer' }}>Business Strategy</li>
                        <li onClick={handleServiceClick} style={{ cursor: 'pointer' }}>Offline Marketing</li>
                    </ul>
                </div>

                {/* Contact Section */}
                <NavLink to="/contactUs" className="footer-section contact">
                    <span className="contact-button">
                        Contact Us
                    </span>
                </NavLink>
            </div>

            {/* Copyright Section */}
            <div className="footer-bottom">
                <div className="copyright">
                    © {new Date().getFullYear()} Born2Scale. All rights reserved.
                </div>
                <div className="footer-links">
                    <NavLink to="/privacy">Privacy Policy</NavLink>
                </div>
            </div>
        </footer>
    );
};

export default Footer;